module.exports = __webpack_public_path__ + "img/builder-4.9bfbe3d7.jpg";